import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0863ac36"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "绑定记录", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "bind-info-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "已绑邀请码", -1))
const _hoisted_5 = { class: "bind-code-value" }

import { computed, ref, withDefaults } from 'vue'
import { useStore } from 'vuex'
import ActivityDialog from './activity-dialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'check-bind-sn',
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ['update:show'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean };



const store = useStore()
const bindCode = computed(() => {
  return store?.state?.OldBringsNew?.bindInviteCode || ''
})

function checkCode() {
  emits('update:show', true)
}

async function updateShowHandle(value: boolean) {
  emits('update:show', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(bindCode))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "bind-record-btn em-container",
          onClick: checkCode
        }, _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(ActivityDialog, {
      show: props.show,
      "onUpdate:show": updateShowHandle
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(bindCode)), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})